// extracted by mini-css-extract-plugin
export default {"wrapper":"Background_wrapper__IzjO4","img":"Background_img__hX2pF","loading":"Background_loading__tkwjp"};